import React, { useState } from 'react';

interface InfoIconProps {
  tooltip?: string;
  onClick?: () => void;
}

export const InfoIcon: React.FC<InfoIconProps> = ({ tooltip, onClick }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <span
      style={{ position: 'relative', display: 'inline-block', marginLeft: '6px' }}
      onMouseEnter={() => tooltip && setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      onClick={onClick}
    >
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '16px',
          height: '16px',
          borderRadius: '50%',
          background: 'var(--brand-primary)',
          color: 'white',
          fontSize: '11px',
          fontWeight: 'bold',
          cursor: onClick ? 'pointer' : 'help',
          userSelect: 'none'
        }}
      >
        i
      </span>
      {showTooltip && tooltip && (
        <div
          style={{
            position: 'absolute',
            top: '24px',
            left: '50%',
            transform: 'translateX(-50%)',
            background: 'var(--surface-inverse)',
            color: 'white',
            padding: '10px 14px',
            borderRadius: '6px',
            fontSize: '12px',
            lineHeight: '1.6',
            whiteSpace: 'pre-line',
            width: '320px',
            zIndex: 1000,
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            pointerEvents: 'none',
            textAlign: 'left'
          }}
        >
          {tooltip}
          <div
            style={{
              position: 'absolute',
              top: '-4px',
              left: '50%',
              transform: 'translateX(-50%) rotate(45deg)',
              width: '8px',
              height: '8px',
              background: 'var(--surface-inverse)'
            }}
          />
        </div>
      )}
    </span>
  );
};

export default InfoIcon;
